import React, { useEffect, useState,useRef } from "react";
import { Modal, Flex, Table, Typography, message } from "antd";
import { EditOutlined } from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";
import moment from "moment";
import commonFn from "@/utils/commonFn";

const { Title } = Typography;

const DetailsModal = ({
  visible,
  onCancel,
  currentRecordId,
}) => {
  const [tableLoading, setTableLoading] = useState(false);
  const [detailsListData, setDetailsListData] = useState([]);
const currentRecordIdRef = useRef(currentRecordId);
const [tableKey, setTableKey] = useState(0);


  const handleCancel = () => {
   
  };


  return (
    <Modal
      title={
        <Flex justify="flex-start" align="flex-start" className="model_title">
          <EditOutlined className="model_title_mr10" />
          <Title level={4} className="mg">
            DETAILS
          </Title>
        </Flex>
      }
      width="80%"
      open={visible}
      onCancel={handleCancel}
      footer={null}
      styles={{
    content: {
      backgroundColor: "#F5F6ED",
    },
    body: {
      height: "80vh",
      padding: "16px 24px",
      overflow: "hidden",
      display: "flex",
      flexDirection: "column",
    },
    header: {
      backgroundColor: "#F5F6ED",
      borderBottom: "1px solid #d4d2d2ff", 
    }
  }}
>
      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          background: "#F5F6ED ",
        }}
      >

      </div>
    </Modal>
  );
};

export default DetailsModal;

